import './labels-alerts.service';
import './labels-api.factory';
import './labels-dialog.service';
import './labels-requests.service';
import './labels-service.service';
